import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useParams } from "react-router-dom";

export const ViewMonitoringDetailContext = createContext(null);

type Props = {
  children: ReactElement;
};

const ViewMonitoringDetailProvider: FunctionComponent<Props> = ({
  children,
}) => {
  const { id } = useParams();

  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["monitoring_detail"],
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`user_monitoring/${id}`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <ViewMonitoringDetailContext.Provider value={contextValue}>
      {children}
    </ViewMonitoringDetailContext.Provider>
  );
};

export default ViewMonitoringDetailProvider;
